var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileEmojy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-38-emojy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1535",
    "data-name": "Rectangle 1535",
    width: 38,
    height: 38,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "smiling-line",
    d: "M15.867,0h0A15.857,15.857,0,0,1,31.731,15.862h0A15.862,15.862,0,0,1,15.867,31.726h0A15.857,15.857,0,0,1,0,15.87H0A15.854,15.854,0,0,1,15.867,0Zm-7.3,10.6a.863.863,0,0,1-1.335-1.09A3.313,3.313,0,0,1,7.7,9.039a5.039,5.039,0,0,1,2.869-1.033,4.625,4.625,0,0,1,3.187.966,4.083,4.083,0,0,1,.581.584A.865.865,0,0,1,13,10.653a2.125,2.125,0,0,0-.341-.323,2.936,2.936,0,0,0-2.012-.584,3.288,3.288,0,0,0-1.862.64,1.516,1.516,0,0,0-.225.217Zm10.537,0a.863.863,0,0,1-1.338-1.09,3.3,3.3,0,0,1,.465-.465A5.051,5.051,0,0,1,21.1,8.006a4.628,4.628,0,0,1,3.189.966,4.222,4.222,0,0,1,.581.584.865.865,0,1,1-1.338,1.1,2.242,2.242,0,0,0-.331-.323,2.939,2.939,0,0,0-2.025-.594,3.293,3.293,0,0,0-1.862.651,1.622,1.622,0,0,0-.222.217ZM6.841,19.454a.863.863,0,1,1,1.513-.824A8.391,8.391,0,0,0,12.445,22.3a9.837,9.837,0,0,0,4.171.793,8.886,8.886,0,0,0,3.972-1.033,7,7,0,0,0,3.125-3.4.867.867,0,0,1,1.6.677,8.713,8.713,0,0,1-3.874,4.228,10.588,10.588,0,0,1-4.749,1.247,11.572,11.572,0,0,1-4.907-.932,10.093,10.093,0,0,1-4.907-4.426ZM15.88,2.022h0A13.853,13.853,0,0,0,2.022,15.867h0A13.855,13.855,0,0,0,15.867,29.712h0A13.855,13.855,0,0,0,29.709,15.864h0A13.853,13.853,0,0,0,15.867,2.022Z",
    transform: "translate(3.141 3.142)",
    fill: "#1dbbbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileEmojy);
export default __webpack_public_path__ + "static/media/smileEmojy.4cf2015fcc4b5cfb9e17c14b2e158ee2.svg";
export { ForwardRef as ReactComponent };